$(document).ready(function() 
{
  
 
  //mr-zoom-gallery
  $(".mr-zoom-gallery").lightGallery({
    getCaptionFromTitleOrAlt:false,
    download:false,
    zoom:true,
    share:false,
    selector:'.mr-gallery-img',
    thumbnail:false,
    loop:false,
    fullScreen:false
  }); 
  
  

 $("#setzoomcustom").on("mouseover", function(){
  
$(this).addClass("fdsfsdf");
  
  
  }); 			
  
  

  
  $('.mr-s-search-frm').click(function()
  {
    $('.mr-stick-search-out').show();
  });
  
  $('.js-search-header-close').click(function()
  {
    $('.mr-stick-search-out').hide();
    $('.site-header__search-input').val("");
  });
  
  $('.owl-carousel').owlCarousel({
    loop: true,
    margin: 0,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1.5,
        nav: true,
        dots:false,
        loop: false
      },
      600: {
        items: 2,
        nav: false,
        dots:false,
        loop: false
      },
      1000: {
        items: 4,
        dots:false,
        nav: true,
        loop: false,
        margin: 0
      }
    }
  });
  
   $('.owl-carousel1').owlCarousel({
                loop: true,
                margin: 0,
                responsiveClass: true,
                responsive: {
                  0: {
                    items: 1.5,
                    nav: true,
                    dots:false
                  },
                  600: {
                    items: 2,
                    nav: false,
                    dots:false
                  },
                  1000: {
                    items: 2,
                    dots:false,
                    nav: true,
                    loop: false,
                    margin: 0
                  }
                }
       }); 
  
  $('.imgal-img').click(function(){
		let imageSrc = $(this).attr("data-singleurl");
		let imageAlt = $(this).attr("alt");
  		$('body').css("overflow","hidden");

		$('.imgal-container').hide();

		$('body').prepend(
			'<div class="imgal-modal">'+'<div class="imgal-modal-inner">'+
			'<span id="imgal-modal-close"">X</span>'+
			'<img src="' + imageSrc + '" alt="' + imageAlt + '" class="imgal-modal-img"></img>'+
			'</div>'
		).hide().show('fast');

		$('#imgal-modal-close').click(function(){
          	$('body').css("overflow","visible");
			$('.imgal-container').show();
			$('.imgal-modal').hide('fast', function(){
				$(this).remove();
			});
		});
  });
  
  
  $(window).scroll(function(){
     let getheightheader = $("#getheaderheight").height();
     let getheighmenu = $("#headercustomsticky").height();
     let getscrollheightcustom = getheightheader + 50 - getheighmenu;
    
    
    
     if ($(window).scrollTop() >= getscrollheightcustom) {
          $('#headercustomsticky').addClass('headercustomfixed');
     }
      else {
          $('#headercustomsticky').removeClass('headercustomfixed');
     }
  });
  
 
  $("#mobilesearchtoggle").click(function(){
   $("#idforhideshowtoggle").toggle();
  });
  
  
  
$("#forreadmore-mainid #forreadmoreid").each(function( index ) {
  $(this).addClass("imgreadmoption"+index);
  
//   console.log( index + ": " + $( this ).text() );
  if("imgreadmoption"+index <= "imgreadmoption4" ){
  
    $(this).css("display","block");
    $("#viewmorereview").css("display","none");
  
  }else{
     $(this).css("display","none");
    $("#viewmorereview").css("display","block");
  }
  
}); 
  
  $("#viewmorereview").on("click", function(){
      $(this).css("display","none");
      $("#viewlessreview").css("display","block");
      $("#forreadmore-mainid #forreadmoreid").css("display","block");
 });  
  $("#viewlessreview").on("click", function(){
        $(this).css("display","none");
        $("#viewmorereview").css("display","block");
        $("#forreadmore-mainid #forreadmoreid").each(function( index ) {
        if("imgreadmoption"+index <= "imgreadmoption4" ){
			$(this).css("display","block");
        }else{
             $(this).css("display","none");
          }

        }); 
 });
  
  $(".footer-collection-content p").each(function( index ) {
    $(this).addClass("imgreadmoption");
    if(index <= 3 ){
      $(this).css("display","block");
      $("#readmorecollectionfooter").css("display","none");

    }else{
      $(this).css("display","none");
      $("#readmorecollectionfooter").css("display","block");
    }
    
  }); 
  
  
$(".footer-collection-content").css("margin-bottom","20px");
  
$(".footer-collection-content").append('<span id="readmorecollectionfooter">Read More</span>');
$(".footer-collection-content").append('<span id="readlesscollectionfooter" style="display:none;">Read Less</span>');
$("#readmorecollectionfooter").on("click", function(){
      $(this).css("display","none");
      $("#readlesscollectionfooter").css("display","block");
      $(".footer-collection-content p").css("display","block");
  	   $(".footer-collection-content").css("margin-bottom","0px");
 });  
  $("#readlesscollectionfooter").on("click", function(){
        $(this).css("display","none");
        $("#readmorecollectionfooter").css("display","block");
    	$(".footer-collection-content").css("margin-bottom","0px");
    
        $(".footer-collection-content p").each(function( index ) {
          $(this).addClass("imgreadmoption");
          if(index <= 3 ){
            $(this).css("display","block");
            $("#readmorecollectionfooter").css("display","none");

          }else{
            $(this).css("display","none");
            $("#readmorecollectionfooter").css("display","block");
          }

        });
 });
if(!$(".footer-collection-content p").hasClass("imgreadmoption")){
    $("#readmorecollectionfooter").css("display","none");
 }
var plenthcountcollectionforpage = $(".footer-collection-content p").length;
if(plenthcountcollectionforpage <= 4 ){
    $("#readmorecollectionfooter").css("display","none");
}
  

  
  
  

  
  
  
});



function getcollectionproduct(id){
  var serialdata = $("#AddToCartFormcollection-"+id).serialize();
    $.ajax({
    type: 'POST',
    url: '/cart/add',
    data:serialdata,
	dataType: 'json',
    success: function(data) {
    //refreshCart(data);
     //$(".js-drawer-open-cart").trigger("click");
     //window.location.href = '/cart';
    },
  }); 
};

function get_variant_id(vid,pid){
  //alert(vid);
  let urlproduct = $("#product_linkulr-"+pid).attr('href');
  $("#product_linkulr-"+pid).attr("href", urlproduct+"?variant="+vid);
};




// $("#AddToCartFormcustom").submit(function() {
//   var serialdata = $("#AddToCartFormcustom").serialize();
//     $.ajax({
//     type: 'POST',
//     url: '/cart/add.js/',
//     data:serialdata,
// 	dataType: 'json',
//     success: function() {
//      window.location.href = '/cart';
//     },
//   }); 
//     return false;
// });



if ($(window).width() > 768) {

 window.addEventListener('DOMContentLoaded', function() {
    (function($) {
	  $(document).ready(function(){
	    $('.shopifyexplorer-zoom')
	      .wrap('<span id="setzoomcustom" style="display:inline-block"></span>')
	      .css('display', 'block')
	      .parent()
	      .zoom({
	        url: $(this).find('img').attr('data-zoom')
	      });
	    });
	  
	})(jQuery);
   });
  
};